import axiosAuth from '../../../shared/configs/axios-auth'

const getDefaultState = () => {
    return {
        clients: [],
        updatingClients: false,
        clientEvents: [],
        updatingClientEvents: false,
        clientInvoices: [],
        updatingClientInvoices: false,
        clientEventEntries: [],
        clientEventInvoices: [],
        clientEventComments: [],
        selectedYear: null,
        selectedClientEvent: null,
        clientEventNotifications: [],
        unapprovedEvents: [],
        updatingUnapprovedEvents: false
    }
}

const state = getDefaultState()

const getters = {
    clients: state => {
        return state.clients
    },
    updatingClients: state => {
        return state.updatingClients
    },
    clientEvents: state => {
        return state.clientEvents
    },
    updatingClientEvents: state => {
        return state.updatingClientEvents
    },
    clientInvoices: state => {
        return state.clientInvoices
    },
    updatingClientInvoices: state => {
        return state.updatingClientInvoices
    },
    updatingClientInvoices: state => {
        return state.updatingClientInvoices
    },
    clientEventInvoices: state => {
        return state.clientEventInvoices
    },
    clientEventComments: state => {
        return state.updatingClientInvoices
    },
    selectedYear: state => {
        return state.selectedYear
    },
    selectedClientEvent: state => {
        return state.selectedClientEvent
    },
    clientEventNotifications: state => {
        return state.clientEventNotifications
    },
    clientEventEntries: state => {
        return state.clientEventEntries
    },
    unapprovedEvents: state => {
        return state.unapprovedEvents
    },
    updatingUnapprovedEvents: state => {
        return state.updatingUnapprovedEvents
    },
}

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    clients: (state, payload) => {
        state.clients = payload
    },
    updatingClients: (state, payload) => {
        state.updatingClients = payload
    },
    clientEvents: (state, payload) => {
        state.clientEvents = payload
    },
    clientEventInvoices: (state, payload) => {
        state.clientEventInvoices = payload
    },
    updatingClientEvents: (state, payload) => {
        state.updatingClientEvents = payload
    },
    clientInvoices: (state, payload) => {
        state.clientInvoices = payload
    },
    updatingClientInvoices: (state, payload) => {
        state.updatingClientEvents = payload
    },
    selectedYear: (state, payload) => {
        state.selectedYear = payload
    },
    selectedClientEvent: (state, payload) => {
        state.selectedClientEvent = payload
    },
    clientEventNotifications: (state, payload) => {
        state.clientEventNotifications = payload
    },
    clientEventEntries: (state, payload) => {
        state.clientEventEntries = payload
    },
    unapprovedEvents: (state, payload) => {
        state.unapprovedEvents = payload
    },
    updatingUnapprovedEvents: (state, payload) => {
        state.updatingUnapprovedEvents = payload
    },
}

const actions = {

    getClients: ({ commit }) => {
        commit('updatingClients', true)
        axiosAuth.get('/administration/clients', {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingClients', false)
                    if (!res.data.message) {
                        commit('clients', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClients', false)
                }
            )
    },

    getUnapprovedEvents: ({ commit }) => {
        commit('updatingUnapprovedEvents', true)
        axiosAuth.get('/administration/unapproved-events', {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    console.log(res)
                    commit('updatingUnapprovedEvents', false)
                    if (!res.data.message) {
                        commit('unapprovedEvents', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingUnapprovedEvents', false)
                }
            )
    },

    getClientEvents: ({ commit }, payload) => {
        commit('clientEvents', [])
        commit('updatingClientEvents', true)
        axiosAuth.get(`/administration/clients/events/${payload.id}?year=${payload.year}`, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingClientEvents', false)
                    if (!res.data.message) {
                        commit('clientEvents', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClients', false)
                }
            )
    },

    updateEventStates: ({ commit, dispatch }, payload) => {
        commit('updatingClientEvents', true)
        commit('updatingUnapprovedEvents', true)
        axiosAuth.patch(`/administration/clients/eventstates/${payload.id}`, payload)
            .then(
                () => {
                    commit('updatingClientEvents', false)
                    commit('updatingUnapprovedEvents', false)
                    dispatch('getUnapprovedEvents')
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClientEvents', false)
                    commit('updatingUnapprovedEvents', false)
                    dispatch('getUnapprovedEvents')
                }
            )
    },

    getClientEventNotifications: ({ commit }, payload) => {
        commit('clientEventNotifications', [])
        commit('updatingClientEvents', true)
        axiosAuth.get(`/administration/clients/eventnotifications/${payload.id}`, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingClientEvents', false)
                    if (!res.data.message) {
                        commit('clientEventNotifications', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClients', false)
                }
            )
    },

    getClientEventEntries: ({ commit }, payload) => {
        commit('clientEventEntries', [])
        commit('updatingClientEvents', true)
        axiosAuth.get(`/administration/clients/evententries/${payload.id}`, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingClientEvents', false)
                    if (!res.data.message) {
                        commit('clientEventEntries', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClients', false)
                }
            )
    },

    getClientEventInvoices: ({ commit }, payload) => {
        commit('clientEventInvoices', [])
        commit('updatingClientEvents', true)
        axiosAuth.get(`/administration/clients/eventinvoices/${payload.id}`, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingClientEvents', false)
                    if (!res.data.message) {
                        commit('clientEventInvoices', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClients', false)
                }
            )
    },

    getClientEventById: ({ commit }, payload) => {
        if (!payload.reset == false)
            commit('selectedClientEvent', null)
        commit('updatingClientEvents', true)
        axiosAuth.get(`/administration/clients/eventById/${payload.id}`, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    commit('updatingClientEvents', false)
                    if (!res.data.message) {
                        commit('selectedClientEvent', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClients', false)
                }
            )
    },

    getClientInvoices: ({ commit }, payload) => {
        console.log('get client invoices')
        commit('clientInvoices', [])
        commit('updatingClientInvoices', true)
        axiosAuth.get(`/administration/clients/events/invoices/${payload.id}?year=${payload.year}`, {
            headers: {
                version: 'v1.1'
            }
        })
            .then(
                res => {
                    console.log(res)
                    commit('updatingClientInvoices', false)
                    if (!res.data.message) {
                        commit('clientInvoices', res.data)
                    }
                }
            )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updatingClientInvoices', false)
                }
            )
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}